module.exports = __webpack_public_path__ + "img/mini-cucumber-sammys.4f3dc251.jpg";